module.exports = __webpack_public_path__ + "assets/img/tri-force-news.06c7d191.svg";